import { render, staticRenderFns } from "./TheAppMenu.vue?vue&type=template&id=3b74b6d4&scoped=true&"
import script from "./TheAppMenu.vue?vue&type=script&lang=js&"
export * from "./TheAppMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheAppMenu.vue?vue&type=style&index=0&id=3b74b6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74b6d4",
  null
  
)

export default component.exports